export default __webpack_public_path__ + "b0d63348f99a92eaeda28f627b9755a3.svg";